'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _FooterPartner = require('./FooterPartner.css');

var _FooterPartner2 = _interopRequireDefault(_FooterPartner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FooterPartner = (_dec = (0, _reactCssModules2.default)(_FooterPartner2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(FooterPartner, _Component);

  function FooterPartner(props) {
    (0, _classCallCheck3.default)(this, FooterPartner);
    return (0, _possibleConstructorReturn3.default)(this, (FooterPartner.__proto__ || (0, _getPrototypeOf2.default)(FooterPartner)).call(this, props));
  }

  (0, _createClass3.default)(FooterPartner, [{
    key: 'render',
    value: function render() {
      var foeLogo = require('../../../static/images/img-foe-logo.png');

      return _react2.default.createElement(
        'div',
        { styleName: 'logo-second-wrap' },
        _react2.default.createElement(
          _components.Link,
          {
            to: _config2.default.links.friends,
            title: 'Friends of the Earth' },
          _react2.default.createElement('img', {
            styleName: 'logo-foe',
            src: foeLogo,
            alt: 'Friends of the Earth'
          })
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'footer-donate-tagline' },
          'Friends of the Earth U.S.'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'footer-social-icons-item' },
          _react2.default.createElement(
            _components.Link,
            {
              to: _config2.default.links.socialFoefb,
              title: 'Friends of the Earth Facebook' },
            _react2.default.createElement('i', { styleName: 'footer-social-icon', className: 'fa fa-facebook-official' })
          ),
          _react2.default.createElement(
            _components.Link,
            {
              to: _config2.default.links.socialFoetwitter,
              title: 'Friends of the Earth Twitter' },
            _react2.default.createElement('i', { styleName: 'footer-social-icon', className: 'fa fa-twitter' })
          )
        )
      );
    }
  }]);
  return FooterPartner;
}(_react.Component)) || _class);
exports.default = FooterPartner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FooterPartner/FooterPartner.js
// module id = 1322
// module chunks = 0